<template>
  <Preloader
    title="Otimizando"
    subtitle="Estamos otimizando a interface do NewsHub para você, aguarde alguns instantes :)"
  />
</template>
<script>
import Preloader from '@/components/shared/Preloader.vue';

export default {
  components: {
    Preloader,
  },
  created() {
    const code = this.$route.query.code;
    this.$store.dispatch('getUserToken', code);
  },
};
</script>
